'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Vue = _interopDefault(require('vue'));
var Component = require('vue-class-component');
var Component__default = _interopDefault(Component);
var functions = require('./functions.js');

function getSlotContents(element, slotName) {
  const slotSelector = slotName ? `slot[name=${slotName}]` : "slot:not([name])";
  const slotNode = element.querySelector(slotSelector);
  return slotNode ? slotNode.assignedElements() : [];
}
function onSlotChange(slot, element, immediate, callback) {
  if (immediate) {
    callback(getSlotContents(element, slot));
  }
  const handler = () => {
    callback(getSlotContents(element, slot));
  };
  element.addEventListener("slotchange", handler);
  return () => {
    element.removeEventListener("slotchange", handler);
  };
}
function SlotChange(slot = "", { immediate } = { immediate: true }) {
  return Component.createDecorator((options, key) => {
    if (!options.methods) {
      options.methods = {};
    }
    const functionToCall = options.methods[key];
    if (!functionToCall && typeof functionToCall !== "function") {
      throw new Error("SlotChange decorator must be decorating a function call");
    }
    let unsub = null;
    options.mounted = functions.hookFunction(options.mounted, function() {
      unsub = onSlotChange(slot, this.$el, immediate, functionToCall.bind(this));
    });
    options.destroyed = functions.hookFunction(options.destroyed, function() {
      if (unsub) {
        unsub();
      }
    });
  });
}
function convertType(constructor, value, hasAttribute) {
  switch (constructor) {
    case Boolean:
      if (value === "false" || !hasAttribute) {
        return false;
      }
      return true;
    case Number:
      return value ? +value : 0;
  }
  return value || "";
}
function SlotData(childName, attributes, slotName = "") {
  return Component.createDecorator((options, key) => {
    const attributeNames = Object.keys(attributes);
    const observedData = Vue.observable({
      [key]: []
    });
    options.computed = options.computed || {};
    options.computed[key] = {
      get() {
        return observedData[key];
      }
    };
    let unsub = null;
    const setAttributeData = (nodes) => {
      Vue.set(observedData, key, nodes.map((node) => {
        const data = {};
        attributeNames.forEach((attr) => {
          data[attr] = convertType(attributes[attr], node.getAttribute(attr), node.hasAttribute(attr));
        });
        return data;
      }));
    };
    options.mounted = functions.hookFunction(options.mounted, function() {
      const emitNodeChange = () => {
        setAttributeData(getSlotContents(this.$el, slotName).filter((element) => {
          return element.tagName.toLocaleUpperCase() === childName.toLocaleUpperCase();
        }));
      };
      const observer = new MutationObserver(emitNodeChange);
      const unsubSlotChange = onSlotChange(slotName, this.$el, true, (nodes) => {
        observer.disconnect();
        nodes.forEach((node) => observer.observe(node, {
          attributes: true,
          attributeFilter: attributeNames
        }));
        emitNodeChange();
      });
      unsub = () => {
        observer.disconnect();
        unsubSlotChange();
      };
    });
    options.destroyed = functions.hookFunction(options.destroyed, function() {
      if (unsub) {
        unsub();
      }
    });
  });
}

exports.SlotChange = SlotChange;
exports.SlotData = SlotData;
